var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { useMemo, } from 'react';
// const totalPageCount = Math.ceil(totalCount / pageSize);
var range = function (start, end) {
    var length = end - start + 1;
    /*
          Create an array of certain length and set the elements within it from
        start value to end value.
      */
    return Array.from({ length: length }, function (_, idx) { return idx + start; });
};
export var usePagination = function (_a) {
    var _b = _a.totalCount, totalCount = _b === void 0 ? 0 : _b, _c = _a.pageSize, pageSize = _c === void 0 ? 12 : _c, _d = _a.siblingCount, siblingCount = _d === void 0 ? 1 : _d, _e = _a.currentPage, currentPage = _e === void 0 ? 1 : _e;
    var paginationRange = useMemo(function () {
        var totalPageCount = Math.ceil(totalCount / pageSize);
        // Pages count is determined as siblingCount + firstPage + lastPage + currentPage + 2*DOTS
        var totalPageNumbers = siblingCount + 5;
        /*
            Case 1:
            If the number of pages is less than the page numbers we want to show in our
            paginationComponent, we return the range [1..totalPageCount]
          */
        if (totalPageNumbers >= totalPageCount) {
            return range(1, totalPageCount);
        }
        /*
              Calculate left and right sibling index and make sure they are within range 1 and totalPageCount
          */
        var leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
        var rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
        /*
            We do not show dots just when there is just one page number to be inserted between the extremes of sibling and the page limits i.e 1 and totalPageCount. Hence we are using leftSiblingIndex > 2 and rightSiblingIndex < totalPageCount - 2
          */
        var shouldShowLeftDots = leftSiblingIndex > 2;
        var shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;
        var firstPageIndex = 1;
        var lastPageIndex = totalPageCount;
        /*
              Case 2: No left dots to show, but rights dots to be shown
          */
        if (!shouldShowLeftDots && shouldShowRightDots) {
            var leftItemCount = 3 + 2 * siblingCount;
            var leftRange = range(1, leftItemCount);
            return __spreadArray(__spreadArray([], leftRange), ['...', totalPageCount]);
        }
        /*
              Case 3: No right dots to show, but left dots to be shown
          */
        if (shouldShowLeftDots && !shouldShowRightDots) {
            var rightItemCount = 3 + 2 * siblingCount;
            var rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
            return __spreadArray([firstPageIndex, '...'], rightRange);
        }
        /*
              Case 4: Both left and right dots to be shown
          */
        if (shouldShowLeftDots && shouldShowRightDots) {
            var middleRange = range(leftSiblingIndex, rightSiblingIndex);
            return __spreadArray(__spreadArray([firstPageIndex, '...'], middleRange), ['...', lastPageIndex]);
        }
    }, [totalCount, pageSize, siblingCount, currentPage]);
    return paginationRange;
};
